export default __webpack_public_path__ + "static/media/water-ultrafiltration-system-500x500.ef747d33.jpg";